import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Mail, ShieldCheck, ArrowRight } from 'lucide-react';
import { BrandLogo } from '@/components/BrandLogo';
import { ThemeToggle } from '@/components/ThemeToggle';

export default function PendingApproval() {
  return (
    <div className="min-h-screen bg-page flex items-center justify-center px-6" data-testid="pending-approval-page">
      <div className="absolute top-4 right-4"><ThemeToggle /></div>
      <div className="w-full max-w-sm fade-up text-center">
        <BrandLogo className="text-ink mb-6 mx-auto block" />
        <div className="w-14 h-14 mx-auto rounded-full border border-line flex items-center justify-center mb-5">
          <Clock strokeWidth={1.5} className="w-7 h-7 text-gold" />
        </div>
        <h1 className="font-serif text-3xl text-ink">Başvurun alındı</h1>
        <p className="text-ink-soft text-sm mt-3 leading-relaxed">
          Teşekkürler! Hesabın yönetici onayından sonra aktifleşecek. Onaylandığında
          e-posta ile bilgilendirilecek ve giriş yapabileceksin.
        </p>

        <div className="mt-6 space-y-3 text-left">
          <div className="flex items-start gap-3 bg-ground border border-line rounded-2xl p-4">
            <Mail strokeWidth={1.5} className="w-5 h-5 text-gold shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-medium text-ink">E-postanı doğrula</p>
              <p className="text-xs text-ink-soft mt-0.5">Gönderdiğimiz doğrulama bağlantısına tıklamayı unutma.</p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-ground border border-line rounded-2xl p-4">
            <ShieldCheck strokeWidth={1.5} className="w-5 h-5 text-gold shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-medium text-ink">Yönetici onayı</p>
              <p className="text-xs text-ink-soft mt-0.5">Ekibimiz başvurunu inceleyip kısa sürede onaylayacak.</p>
            </div>
          </div>
        </div>

        <Link to="/giris" data-testid="pending-goto-login"
          className="w-full mt-6 inline-flex items-center justify-center gap-2 bg-ink text-ground py-3.5 rounded-xl font-semibold transition-transform active:scale-95">
          Giriş sayfasına dön <ArrowRight strokeWidth={1.5} className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
